import {POI, POIUtility} from "../models/POI";
import {generateRandomInt} from "./IDGenerator";
import {createIndividualWaypointGeoJsonObjectHelper} from "./CreateIndividualWaypointGeoJsonObjectHelper";
import {createWaypointMapLayerHelper} from "./CreateWaypointMapLayerHelper";
import mapboxgl from "mapbox-gl";
import {MapLayerCategory} from "../layer-registry"; // Import mapboxgl type if not already

export function addWaypointToMapHelper(poiType: POI, clientId: string, lngLat: {lng: number, lat: number}): string {
  // Generate unique ID for this specific waypoint's source and layer
  let randomId = "waypoint-" + generateRandomInt();
  const map = window.map as mapboxgl.Map; // Assert type for better intellisense

  if (!map) {
    console.error("Map not available in addWaypointToMapHelper");
    return ""; // Return empty or throw error if map must exist
  }

  try {
    // Add the source for the individual waypoint
    const source = {
      "type": "geojson",
      "data": createIndividualWaypointGeoJsonObjectHelper(clientId, lngLat, poiType)
    }
    const layerConfig = createWaypointMapLayerHelper(randomId); // Pass source ID too if helper needs it
    window.layerRegistry.addSource(randomId, source, true); // Add the source to the map
    window.layerRegistry.addLayer(layerConfig, MapLayerCategory.Top);

    // Create the layer configuration using the helper
    // *** Assumption: createWaypointMapLayerHelper uses the passed ID as the layer's ID ***

    // --- Add Cursor Listeners Directly ---
    map.on('mouseenter', randomId, () => {
      // Only change if map and canvas still exist
      if (map.getCanvas()) {
        map.getCanvas().style.cursor = 'pointer';
      }
    });
    map.on('mouseleave', randomId, () => {
      // Only change if map and canvas still exist
      if (map.getCanvas()) {
        map.getCanvas().style.cursor = '';
      }
    });
    // --- End Listener Addition ---

  } catch (e) {
    console.error(`Error adding individual waypoint source/layer ${randomId}:`, e);
    // Clean up if source was added but layer failed?
    if (map.getSource(randomId)) {
      map.removeSource(randomId);
    }
    return ""; // Indicate failure
  }

  return randomId; // Return the unique ID for tracking
}
